<template>
    <header>
            <h1 class="site-heading text-center text-faded d-none d-lg-block">
                <span class="site-heading-lower">Syfabrik</span>
                <span class="site-heading-upper text-primary mb-3">Sewing Factory</span>
            </h1>
        </header>
</template>